import { GaGetAccountsResponseType } from "@intelligems/ig-types";
import { QueryObserverOptions, useQuery } from "@tanstack/react-query";

import { QueryMeta } from "../../types/react-query";
import { api } from "../api";
import { gaKeys } from "../queryKeys";

export const getGaAccounts = async (): Promise<GaGetAccountsResponseType> => {
  const resp = await api.get<GaGetAccountsResponseType>(
    `/v2/integrations/google/ga/accounts`
  );
  return resp.data;
};

export const useGetGaAccounts = (
  enabled: boolean,
  options?: QueryObserverOptions<GaGetAccountsResponseType, Error>
) => {
  return useQuery<GaGetAccountsResponseType, Error>({
    ...options,
    queryKey: gaKeys.accounts(),
    queryFn: async () => getGaAccounts(),
    enabled,
    meta: {
      onError: {
        401: "ignore",
      },
    } as QueryMeta,
  });
};
